import { tempMeeApi } from '~/services/api';
import { scopedHeaders } from '~/services/scopedHeaders';
import { IRetryBillingResultEntity } from '../types';

/** @param officeId - retries that office's plan billing (its `x-office`) over the selected one's */
export const retryBilling = async (officeId?: string): Promise<IRetryBillingResultEntity[]> => {
  const headers = await scopedHeaders(officeId);

  const response = await tempMeeApi.post<IRetryBillingResultEntity[]>(
    `/payment/user/office-plan/retry-billing`,
    {},
    { headers },
  );

  return response.data;
};
